// src/axiosPlugin.mjs
import axiosInstance from "./axiosInstance";

export default {
  install: (app) => {
    app.config.globalProperties.$axios = axiosInstance;
    // const axiosInstance = axios.create({
    //   baseURL: "http://localhost:8083/api",
    //   headers: {
    //     // Authorization: "Bearer token",
    //     "Content-type": "application/json",
    //   },
    // });

    // Interceptor per debug degli errori
    // axiosInstance.interceptors.response.use(
    //   (response) => response, // Restituisci la risposta se è valida
    //   (error) => {
    //     console.error("Errore Axios:", error.response || error.message); // Log degli errori
    //     return Promise.reject(error); // Propaga l'errore
    //   }
    // );
  },
};
